import { Box, VStack } from 'native-base';
import PlanDetails from '~/pages/subscriptions/components/planDetails';
import EmailVerificationForm from '~/shared/EmailVerification/EmailVerificationForm';
import SubscribeForm from '~/pages/subscriptions/components/SubscribeForm';
import CreditCardForm from '~/shared/CreditCardForm/CreditCardForm';
import { Plan } from '@springbig/shared';
import { H3 } from '~/shared/Typography';
import SubscribeSuccessScreen from '~/pages/subscriptions/components/SubscribeSuccessScreen';
import useSubscribeFlow from '~/pages/subscriptions/hooks/useSubscribeFlow';
import { useI18n } from '@springbig/shared';
import { useAppNavigate } from '~/pages';
import React from 'react';

type SubscribeFlowProps = {
  plan: Plan;
};

const SubscribeFlow = ({ plan }: SubscribeFlowProps) => {

    const { t } = useI18n();
    const { params } = useAppNavigate();
    const {
        isPlanDetails,
        isEmailVerification,
        isCreditCardFormSubscribe,
        isSubscribeSuccess,
        priceSummary,
        apiError,
        isLoadingSubscribe,
        onSubscribeCancel,
        onSubscribeProceed,
        onEmailVerificationCancel,
        onEmailVerificationProceed,
        onCancelCreditCardFormSubscribe,
        onSubmitCreditCardFormSubscribe,
        onSubscribeSuccessProceed,
        onUpdateBillingSchedule,
    } = useSubscribeFlow({
        plan,
    });

    return (
        <Box>
            { plan && isPlanDetails &&
                <PlanDetails
                    plan={plan}
                    onCancel={onSubscribeCancel}
                    onProceed={onSubscribeProceed}
                />
            }
            { isEmailVerification &&
                <VStack space={10} p={4}>
                    <H3
                        textAlign={'center'}
                        text={'subscriptions.email_verification'}
                    />
                    <EmailVerificationForm
                        t={t}
                        isRequiredTerms
                        walletId={params.wallet_id}
                        onCancel={onEmailVerificationCancel}
                        onProceed={onEmailVerificationProceed}
                    />
                </VStack>
            }
            { plan && isCreditCardFormSubscribe &&
                <SubscribeForm
                    t={t}
                    plan={plan}
                    onUpdateBillingSchedule={onUpdateBillingSchedule}
                    isLoading={isLoadingSubscribe}
                >
                    <CreditCardForm
                        onCancel={onCancelCreditCardFormSubscribe}
                        onProceed={onSubmitCreditCardFormSubscribe}
                        summary={priceSummary}
                        error={apiError}
                        submitButtonText={'credit_card.subscribe_button'}
                        isLoading={isLoadingSubscribe}
                    />
                </SubscribeForm>
            }
            { plan && isSubscribeSuccess &&
                <SubscribeSuccessScreen
                    plan={plan}
                    onProceed={onSubscribeSuccessProceed}
                />
            }
        </Box>
    );
};

export default SubscribeFlow;
